module.exports = __webpack_public_path__ + "img/Wp_2072.e540a444.png";